// eslint-disable-next-line
import React from 'react';
import ProjectCard from '../components/ProjectCard';
import { FaGithubSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa';

function Projects() {
  return (
    <div className="body">
      <div className="social-links-sm">
        <a
          href="https://github.com/srishti-maurya"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithubSquare size={25} />
        </a>
        <a
          href="https://www.linkedin.com/in/mauryasrishti22/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin size={25} />
        </a>
        <a
          href="https://twitter.com/SrishtiMaurya1?s=09"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitterSquare size={25} />
        </a>
      </div>
      <div className="project-heading-container">
        <img
          src="./images/office-board.png"
          className="coding"
          alt="about-img"
        />
        <div className="ml-lg">
          <h2 className="about-heading">Some Things I’ve Built</h2>
          <h5 className="projects-content a">
            Here are a few projects I've worked on
          </h5>
        </div>
      </div>

      <ProjectCard
        isFeatured
        projectImg="./images/eCom.png"
        title="Plan it, Shop it - E-commerce App"
        githubRep="https://github.com/srishti-maurya/plan-it-shop-it-eComm-react/tree/dev"
        liveLink="https://planit-shopit.netlify.app/"
        projDesc="
        
        Built using - 
ReactJS,
React Router v6,
React Context API and useReducer,
MockBee,
Plan it, Use it - CSS Component Library,
React Tostify;
Features -
Landing page with a list of featured categories and featured products,
Product Listing page,
Sort and filter products,
Authentication,
Wishlist Management,
Cart Management,
Toasts"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        isDark
        isFeatured
        projectImg="./images/compLib.png"
        title="Plan it, Use it - Component Library"
        githubRep="https://github.com/srishti-maurya/Plan-it-Component-Library/tree/develop"
        liveLink="https://develop--planit-useit.netlify.app/index.html"
        projDesc="A CSS library, integrated with pre-defined styled classes, and Utilites. Helping you to focus more on logic/ functionality. Copy and paste the components at one click."
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        isFeatured
        projectImg="./images/notesApp.png"
        title="Plan it, Note it - Notes Taking App"
        githubRep="https://github.com/srishti-maurya/plan-it-note-it/tree/dev"
        liveLink="https://planit-noteit.netlify.app/"
        projDesc="Features -
        Landing page,
        Add a new note,
        Edit & Delete Note,
        Filter & Sort by date and priority,
        Change Card Color,
        Add Tags to notes,
        Archive Notes,
        Delete Notes,
        Authentication,
        Toasts;
        
        Built using - 
        ReactJS,
        React Router v6,
        React Context API and useReducer,
        MockBee,
        Plan it, Use it - CSS Component Library,
        React Hot Toast"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        isDark
        projectImg="./images/newsApp.png"
        title="News App"
        githubRep="https://github.com/srishti-maurya/react-native-news-app"
        projDesc="Features Added -
        Search news,
        Display news category wise,
        Display news sources wise,
        Theme (Light/ Dark),
        Read full news and summaries news;
        Concepts Used -
        Hooks (useState, useEffect, useContext),
        API call via axios"
        isHtml
        isCss
        isReactnative
      />
      <ProjectCard
        isFeatured
        projectImg="./images/videoLib.png"
        title="Plan it, Watch it - Video Library"
        githubRep="https://github.com/srishti-maurya/planit-watchit/tree/dev"
        liveLink="https://planit-watchit.netlify.app/"
        projDesc="
        
        Built using - 
ReactJS,
React Router v6,
React Context API and useReducer,
MockBee,
Plan it, Use it - CSS Component Library,
React Tostify;
Features -
Video Listing page,
Filtered videos,
Playlist Management,
Like videos,
Watch Later,
History"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        isDark
        projectImg="./images/project-portfolio.png"
        title="Pure HTML, CSS Portfolio"
        githubRep="https://github.com/srishti-maurya/Portfolio"
        liveLink="https://srishti-portfolio.netlify.app/"
        projDesc="A pure HTML and CSS based portfolio which displays basic information, projects worked and blogs."
        isHtml
        isCss
      />
      <ProjectCard
        projectImg="./images/project-author.png"
        title="Guess the author!"
        githubRep="https://replit.com/@srishtimaurya/Guess-the-writer"
        liveLink="https://replit.com/@srishtimaurya/Guess-the-writer?embed=1&output=1"
        projDesc="A CLI app built with nodeJS. A quiz game about the popular novels and authors."
        isNodejs
        isJs
      />
      <ProjectCard
        isDark
        projectImg="./images/project-birthday.png"
        title="Are you a lucky person?"
        projDesc="This luck calculator takes user’s date of birth and their considered lucky number and after few calculations displays the results with the help of graphics."
        githubRep="https://github.com/srishti-maurya/is-your-birthday-lucky"
        liveLink="https://imlwv.csb.app/"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        projectImg="./images/project-blog.png"
        title="Blog website"
        projDesc="A blog (a shortened version of “weblog”) is an online journal or informational website displaying information. It is a platform where a writer or a group of writers share their views on an individual subject. This website allows the user to compose new blog and preserve showcase it."
        githubRep="https://github.com/srishti-maurya/Blog-website"
        isHtml
        isCss
        isJs
        isMongo
      />
      <ProjectCard
        isDark
        projectImg="./images/project-cash.png"
        title="Cash register manager"
        projDesc="A simple cash register manager, it calculates the number of notes and amount to be given back once the bill amount and the cash received is entered."
        githubRep="https://github.com/srishti-maurya/cashRegister"
        liveLink="https://srishti-maurya.github.io/cashRegister/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        projectImg="./images/all-mini-proj.png"
        title="Mini Projects"
        projDesc="Displays mini projects developed during learning phase. From mini projects worked on HTML, CSS, Tailwind CSS, Bootstrap, JavaScript, TypeScript, ReactJs."
        githubRep="https://github.com/srishti-maurya/all-Mini-Projects"
        liveLink="https://srishti-maurya.github.io/all-Mini-Projects/"
        isHtml
        isCss
        isJs
        isReact
      />
      <ProjectCard
        isDark
        projectImg="./images/project-dice.png"
        title="Dice game"
        projDesc="It generates 2 random dice numbers and accordingly declares the winner."
        githubRep="https://github.com/srishti-maurya/Dice-Challenge-Game"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        projectImg="./images/project-drumkit.png"
        title="Drum kit player"
        projDesc="Talking about the gameplay, it is a simple musical game. It is a simple arcade game which is played with a tap. The user has to use the keyboard in order to play the game."
        githubRep="https://github.com/srishti-maurya/Drum-kit-"
        liveLink="https://srishti-maurya.github.io/Drum-kit-/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        isDark
        projectImg="./images/project-emoji.png"
        title="World of emoji"
        projDesc="The emoji search engine. A fast emoji search experience with options to browse emoji."
        githubRep="https://codesandbox.io/s/markseven-8w60r?file=/src/App.js"
        liveLink="https://8w60r.csb.app/"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        projectImg="./images/project-goodbooks.png"
        title="Goodbooks"
        projDesc="Do you read books? You would find some good recommendations for different genre along with the author’s name."
        githubRep="https://codesandbox.io/s/goodbooks-eb5zc?file=/src/App.js"
        liveLink="https://eb5zc.csb.app/"
        isHtml
        isCss
        isReact
      />
      <ProjectCard
        isDark
        projectImg="./images/project-keeper.png"
        title="Keeper notes"
        projDesc="A user friendly note keeping app, where a user can create new a note, read it and delete it after completion."
        githubRep="https://github.com/srishti-maurya/Keeper-Notes"
        isHtml
        isCss
        isReact
        isMongo
      />
      <ProjectCard
        projectImg="./images/project-marvel.png"
        title="Guess the marvel character!"
        projDesc="A CLI app built with nodeJS. A fun quiz game about the popular marvel character."
        githubRep="https://replit.com/@srishtimaurya/levelZeroAvengersGame?embed=1&output=1"
        liveLink="https://replit.com/@srishtimaurya/levelZeroAvengersGame"
        isHtml
        isCss
        isReact
        isMongo
      />
      <ProjectCard
        isDark
        projectImg="./images/project-minion.png"
        title="Minion translator"
        projDesc="Convert from English to Minion speak. This language is spoken by the minions in Despicable Me. The language is actually lots of languages. Yi kai yai yai bananna! Minion is a registered trademark of Universal Studios."
        githubRep="https://github.com/srishti-maurya/VanillaJS-markSix"
        liveLink="https://srishti-maurya.github.io/VanillaJS-markSix/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        projectImg="./images/project-palindrome.png"
        title="Is your birthday palindrome?"
        projDesc="Tells the user if their birthdates is a palindrome number. Also, tells them by how many days they missed it."
        githubRep="https://codesandbox.io/s/checkdateispalindrome-1v93v"
        liveLink="https://1v93v.csb.app/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        isDark
        projectImg="./images/project-quiz.png"
        title="Do you know Srishti?"
        projDesc="A CLI app built with nodeJS. A fun quiz game for friends to test how much they know Srishti!"
        githubRep="https://replit.com/@srishtimaurya/levelZero-markOne"
        liveLink="https://replit.com/@srishtimaurya/levelZero-markOne?embed=1&output=1"
        isNodejs
        isJs
      />
      <ProjectCard
        projectImg="./images/project-simon.png"
        title="Simon game"
        projDesc="The game creates a series of tones and lights and requires a user to repeat the sequence. If the user succeeds, the series becomes progressively longer and more complex. Once the user fails or the time limit runs out, the game is over."
        githubRep="https://github.com/srishti-maurya/Simon-Game"
        liveLink="https://srishti-maurya.github.io/Simon-Game/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        isDark
        projectImg="./images/project-stock.png"
        title="Stock calculator"
        projDesc="This calculator takes purchase price, stock quantity and current price as input and then
        tells the user how much profit or loss he/she is making on a stock."
        githubRep="https://codesandbox.io/s/stock-price-ty8iv"
        liveLink="https://ty8iv.csb.app/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        projectImg="./images/project-translator.png"
        title="Shakespeare translator"
        projDesc="Convert from English to Shakespeare. Shakespeare invented many words and his style of narration in many ways was unique to his time. His ever popular works ( dramas and poems ) makes his language style live even today. This translator takes English as input and converts to Shakespeare English."
        githubRep="https://github.com/srishti-maurya/Shakespeare-translator"
        liveLink="https://english-to-shakespeare-translator.netlify.app/"
        isHtml
        isCss
        isJs
      />
      <ProjectCard
        isDark
        projectImg="./images/project-triangle.png"
        title="Triangle calculator"
        projDesc="This calculator allows the user to calculate (1) the area of triangle under 3 different conditions, (2) hypotenuse of the triangle and (3) check whether a triangle can be formed with the given angles.
        It also has a fun section where user can take a short quiz about triangle."
        githubRep="https://github.com/srishti-maurya/know-shapes"
        liveLink="https://doyou-know-triangles.netlify.app/"
        isHtml
        isCss
        isReact
      />
    </div>
  );
}

export default Projects;
